/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MappaPastoScuola { 
    chiave?: MappaPastoScuolaChiaveEnum;
    valore?: string;
}
export enum MappaPastoScuolaChiaveEnum {
    DOCENTI = 'DOCENTI',
    PERSONALE_ATA = 'PERSONALE_ATA',
    PERSONALE_TECNICO = 'PERSONALE_TECNICO',
    COLLABORATORI = 'COLLABORATORI'
};



